<template>
  <div id="index">
    <div v-if="idloading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
        <div>努力加载中...</div>
      </div>
    </div>
    <div v-else class="visible-xs min_index ">
      <!-- 头部 -->
      <header class="flex_center m_header">
        <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt=""></i>
        <h4 class="header_title">内容文件</h4>
      </header>

      <div v-if="is_content_power==1">
        <div class="sousuo_box">
          <div class="sousuo_div flex_between">
            <i><img src="@/assets/img/searche.png" alt=""></i>

            <input type="text" placeholder="请输入搜索的内容" @blur="searchFun" v-model="search_text" name="" id="">
          </div>
        </div>

        <!-- 导航 -->
        <div class="head_top flex_between">
          <div class="head_left">
            <div class="head_ul">
              <div class="head_li flex_center" v-for="(liem, index) in recommended_arr.length>8?recommended_arr.slice(0,8):recommended_arr" :class="{ selected: recommended_id == liem.conf_id }" @click.stop="recommendedFun(index)" :key="index">
                {{ liem.title }}
              </div>
              <div class="head_li flex_center" @click="is_menu = true">
                更多
              </div>
            </div>
          </div>
          <i class="head_right" @click="is_menu = true"><img src="@/assets/img/menu_icon.png" alt="" /></i>
        </div>
        <div class="">
          <div style="height:130px;width:100%"></div>

          <m_listContent v-if="list_arr.length > 0" :list_arr="list_arr" ref="listLi" @detailsFun="detailsFun"></m_listContent>
          <div class="complete" v-else-if="is_request">
            <div class="claloadding">
              <div>
                <img src="@/assets/img/kkry_pc.gif" alt="">
              </div>
              <div>暂无数据</div>
            </div>
          </div>
          <div class="complete" v-else>
            <div class="claloadding">
              <img src="@/assets/img/loadding_pc.gif" alt="">
              <div>努力加载中...</div>
            </div>

          </div>
        </div>
        <!-- 菜单弹窗 -->
        <div class="menu_popup" v-if="is_menu">
          <i class="popup_esc" @click="is_menu = false">
            <img src="@/assets/img/cha.png" alt="" />
          </i>
          <div class="menu_div">
            <div class="head_li flex_center" v-for="(liem, index) in recommended_arr" :key="index" :class="{ selected: recommended_id == liem.conf_id }" @click.stop="recommendedFun(index, 2)">
              {{ liem.title }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="not-auth">
        {{no_power_msg}}
      </div>
      <waterBox />
    </div>

  </div>
</template>

<script>
import MinHeader from "@/components/m_assembly/MinHeader.vue"; //头部模块
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
import m_listContent from "@/components/assembly/m_listContent.vue"; //列表数据模块
import Hezuo from '@/components/tool/m_hezuo.vue'
import waterBox from "@/components/assembly/waterBox.vue";
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";

export default {
  name: "m_column",
  data() {
    return {
      is_menu: false, //是否菜单列表
      user: {}, //用户信息
      recommended_id: 0, //导航 index
      recommended_arr: [], //导航列表
      page: 1,
      list_arr: [],
      search_text: "", //搜索内容
      is_request: false,
      idloading: true,
      is_content_power: 0,
      no_power_msg:''
    };
  },
  computed: {
    MembershipType: function () {
      return this.MembershipGrade(this.user.plus);
    },
  },
  components: {
    MinHeader,
    LoginPrompt,
    m_listContent,
    Hezuo,
    waterBox
  },

  methods: {
    goBackward() {//返回上一页
      this.$router.replace("/m_my");
    },
    judgeUser() {
      //判断用户数据
      if (this.USER() && this.USER() !== {}) {
        this.REFRESH_USER();
      } else {
        this.$refs.prompt.popupFun();
      }
    },
    recommendedFun(index, type) {
      //切换导航
      this.recommended_id = this.recommended_arr[index].conf_id;
      this.getList();
      if (type == 2) {
        setTimeout(() => {
          $(".head_left").scrollLeft($(".selected").offset().left);
        }, 500);
      }
    },

    searchFun() {
      this.page = 1;
      this.getList();
    },
    detailsFun(id) {
      //查看详情
      this.$router.push({
        path: "/m_content_details",
        query: { id: id, },
      });
    },
    promptFun() {
      //提示弹窗回调
      this.$router.replace("/m_registered");
    },
    getUser() {
      let that = this;
      this.REFRESH_USER();
      that.user = that.USER();
    },
    getList() {
      //获取列表数据
      let that = this;
      this.is_request = false;
      if (this.page == 1 || this.recommended_id == 0) {
        this.list_arr = [];
      }
      this.$get("content_lists", {
        conf_id: this.recommended_id,
        limit: 10,
        page: this.page,
        keyword: this.search_text,
        member_id: this.USER().id,
      }).then((res) => {
        this.no_power_msg = res.data.power_msg;
        that.is_request = true;
        let arr = res.data.data.data
        that.list_arr = that.list_arr.concat(arr);
        this.is_content_power = res.data.is_content_power;
      });
    },
    getNews() {
      //获取栏目
      let that = this;
      if (this.$route.query.id) {
        this.recommended_id = this.$route.query.id;
      }
      this.$get("content_conf", {
        page: 1,
        limit: 999,
        member_id: this.USER().id,
      }).then((res) => {
        that.recommended_arr = res.data.data;
        this.recommended_arr.unshift({
          conf_id: 0,
          title: "全部"
        })
      });
    },
  },
  activated() {

  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = false
    let that = this;
    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }

    this.recommended_id = this.$store.state.column_id;
    document.title = "麻醉眼界";
    this.list_arr = [];
    this.getNews();
    this.getShare();
    this.getUser();
    this.page = 1;
    this.list_arr = [];
    this.getList();
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        that.getList();
      }
    });
  },
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
}

#index {
  /* padding-top: 90px; */
}

header.header {
  box-shadow: 0 !important;
}
.m_header {
  box-shadow: none;
}
.sousuo_box {
  position: fixed;
  top: 45px;
  left: 0;
  width: 100%;
  background-color: #fff;
}
.sousuo_box .sousuo_div {
  border: 1px solid rgba(153, 153, 153, 0.5);
  border-radius: 6vw;
  height: 37px;
  margin: 0 10px;
}

.sousuo_box .sousuo_div > i {
  width: 1.7rem;
  height: 1.7rem;
  margin: 0.9rem;
}

.sousuo_box .sousuo_div > input {
  flex: 1;
  margin-right: 10px;
  font-size: 1.2rem;
  border: 0;
  height: 100%;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem !important;
}

/* 导航 */
.min_index .head_top {
  position: fixed;
  top: 85px;
  left: 0;
  right: 0;
  padding: 0 1.6rem;
  background: #fff;
  box-shadow: 0 5px 9px rgba(71, 71, 71, 0.11);
  z-index: 998;
  overflow-x: auto;
  white-space: nowrap;
}
.claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.head_top .head_left {
  flex: 1;
  overflow: hidden;
  overflow-x: auto;
}

.head_top .head_right {
  width: 2rem;
  margin-left: 1rem;
}

.head_top .head_li {
  height: 3.8rem;
  display: inline-flex;
  position: relative;
  font-size: 1.4rem;
  margin-right: 2rem;
  color: #999;
  border-bottom: 0.15rem solid #fff;
}

.head_top .head_li.selected {
  color: #333;
  font-weight: bold;
  border-color: #f04c61;
}

/* 菜单弹出 */
.menu_popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f9fbfe;
  z-index: 999;
}

.menu_popup .popup_esc {
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 1.6rem;
  left: 1.6rem;
}

.menu_popup .menu_div {
  margin-top: 6rem;
  padding: 0 1rem 6rem 1rem;
  height: calc(100vh - 6rem);
  overflow-y: auto;
}

.menu_popup .menu_div .head_li {
  min-width: calc(25% - 1rem);
  height: 3rem;
  padding: 0 1rem;
  border-radius: 0.5rem;
  background: #dfdfdf;
  color: #666666;
  font-size: 1.4rem;
  margin: 0.5rem;
  display: inline-flex;
}

.menu_popup .menu_div .head_li.selected {
  background: #f24d5b;
  color: #fff;
}

.list_head {
  padding: 1rem 2rem 1rem 2rem;
  border-bottom: 0.05rem solid #f1f1f1;
}

.list_head .list_title {
  font-size: 2rem;
  color: #333;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_content_file.vue